import React from 'react';
import BreadcrumbItem from "../component/BreadcrumbItem/BreadcrumbItem";
import Page from "../component/Page/Page";
import GatewayForm from "./GatewayForm";

class GatewayFormPage extends React.Component {
  render() {
    const {match, history} = this.props;
    const breadcrumbs = [
      <BreadcrumbItem key={1} title="Cadastros"/>];
    return (
        <Page title="Dados do gateway" breadcrumbs={breadcrumbs}>
          <GatewayForm match={match} history={history}/>
        </Page>
    );
  }
}

export default GatewayFormPage;



// WEBPACK FOOTER //
// ./src/gateways/GatewayFormPage.js